<template>
  <DiscountSingle
    :discount="discount"
  />
</template>

<script>
import DiscountSingle from '../components/DiscountSingle'

export default {
  name: 'CampaignsSingle',

  components: {
    DiscountSingle
  },

  async beforeRouteLeave (to, from, next) {
    if (this.discount && this.discount.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.discount.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      previous: {
        text: 'Back',
        url: 'discounts'
      },
      title: 'Discount',
      actions: [
        {
          text: '',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      discount: {}
    }
  },

  computed: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    saveActionStates () {
      const hasKeys = Object.keys(this.discount).length

      return {
        disabled: !this.discount || (hasKeys && (this.discount.inProgress || !this.discount.isDirty() || this.discount.errors.length)),
        loading: this.discount && this.discount.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.discount || this.discount.inProgress,
        hidden: this.isCreate
      }
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    async init () {
      this.$radio.$emit('action-panel-actions-update', { event: 'save', action: { text: this.isCreate ? 'Create' : 'Save' } })
      try {
        const discount = (this.isCreate)
          ? this.$http.make('campaign')
          : await this.$http.campaign.find(this.$route.params.id)

        if (!discount.condition || Array.isArray(discount.condition)) {
          discount.condition = {
            children: [],
            logicalOperator: 'All',
            subsets: []
          }
        }

        // TODO: server fix - always children in first level
        if (!discount.condition.children) {
          discount.condition.children = []
          discount.condition.children.push({ query: {
            rule: discount.condition.rule || '',
            selectedOperator: discount.condition.selectedOperator || '',
            type: discount.condition.type || '',
            value: discount.condition.value || '',
            logicalOperator: discount.condition.logicalOperator || 'All'
          } })
          discount.condition.logicalOperator = 'All'
        }

        if (!discount.condition.subsets) {
          discount.condition.subsets = []
        }

        if (discount.condition.children) {
          discount.condition.children = discount.condition.children.map(child => {
            if (child.query.children && child.query.children.length && !child.query.subsets) {
              child.query.subsets = []
            }

            return child
          })
        }

        delete discount.condition.rule
        delete discount.condition.type
        delete discount.condition.value
        delete discount.condition.selectedOperator

        this.discount = discount
      } catch (e) {
        this.$toast.error(this.$t(e.message))
      }

      if (this.isCreate) {
        this.$radio.$emit('action-panel-title', 'New Discount')
      } else {
        this.$radio.$emit('action-panel-title', this.discount.name)
      }
    },

    async onActionSave () {
      const without = (this.discount.type !== 'coupon') ? 'code' : ''
      await this.clearConditions()

      if (this.discount.condition && this.discount.condition.children && this.discount.condition.children.length === 0) {
        this.discount.condition = null
      }

      try {
        await this.discount
          .without([without])
          .save()

        this.$toast.info(this.$t('Discount saved'))

        if (this.isCreate) {
          await this.$router.replace({
            name: 'single-discount',
            params: { id: this.discount.id }
          })
          this.init()
        }
      } catch (e) {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
      }
    },

    async onActionDelete () {
      await this.discount.delete()
      this.$router.replace({ name: 'discounts' })
    },

    async clearConditions () {
      if (this.discount.condition === null || this.discount.condition.children === null) {
        return
      }

      this.discount.condition.children = await this.discount.condition.children.filter(children => {
        if (children.query.children) {
          children.query.children = children.query.children.filter(child => {
            return this.checkRules(child.query)
          })
          return children.query.children.length
        } else {
          return this.checkRules(children.query)
        }
      })
    },

    checkRules (query) {
      return query.rule && query.value
    }
  }
}
</script>
